export const project = 'conversant'; // need this for when we dynamically import utils

/**
 * Searches cookies for a specified name and returns the value if available.
 * Defaults to returning an empty string. This function is a modified
 * version of readCookieDotomi() from the standard Conversant tag.
 *
 * @param {string} searchVal the name of the cookie value to retrieve
 * @returns {string} The cookie value
 */
const readCookieDotomi = (win, cookieName) => {
	const searchVal = `${cookieName}=`;
	let cookieVal = '';

	win.document?.cookie?.split(';')?.forEach((cookie) => {
		if (cookie) {
			const cleanedCookie = cookie.replace(/^\s+/g, '');
			if (cleanedCookie?.indexOf(searchVal) === 0) {
				cookieVal = cleanedCookie.substring(
					searchVal.length,
					cleanedCookie.length
				);
			}
		}
	});

	return cookieVal;
};

export const getUserToken = ({ window: win }) =>
	readCookieDotomi(win, 'dtm_token');

export const getFpcStatus = ({ window: win }) =>
	readCookieDotomi(win, 'DotomiStatus');

/* eslint-disable no-param-reassign */
export const sending = ({ win, data = {}, preview = false }) => {
	if (!preview) {
		const dtmSrc =
			'//login.dotomi.com/ucm/UCMController?dtm_com=28&dtm_format=5';
		const dtmParams = Object.entries(data)
			?.map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
			?.join('&');
		win.dtmSrc = `${dtmSrc}&${dtmParams}`;

		// Add Conversant div and iframe to page body
		const newDotomiNode = win.document.createElement('div');
		const newIFrame = win.document.createElement('iframe');
		newDotomiNode.style.display = 'none';
		newDotomiNode.id = 'dtmdiv';
		newIFrame.name = 'response_frame';
		newIFrame.src = win.dtmSrc;
		newDotomiNode.appendChild(newIFrame);
		win.document.body.appendChild(newDotomiNode);

		// If preventtimeout=true is added to url, setTimeout function won't fire
		if (
			new URL(window.location).searchParams.get(
				'_conversantpreventtimeout'
			) !== 'true'
		) {
			// Clears the contents of dtmdiv
			setTimeout(() => {
				win.document.getElementById('dtmdiv').innerHTML = '';
			}, 5000);
		} else {
			// this.log.debug('timeout prevented - will not remove #dtmdiv iframe');
		}
	}

	const sender = 'div#dtmdiv iframe > login.dotomi.com/ucm/UCMController';

	return {
		reportsForNewRelic: [
			{
				clientEventName: data?.cli_promo_id,
				sender
			}
		],
		reportsForEventViewer: [
			{
				payload: data,
				sender
			}
		]
	};
};
/* eslint-enable no-param-reassign */

/**
 *
 * @param {Object} {vehicles} is the DDC.dataLayer.vehicles object
 * @returns A string of the packages for the first vehicle in the array
 */
export const getPackageNames = ({ vehicles = [] }) =>
	vehicles?.[0]?.packages
		?.map(
			({ packageName, includedOptionList = [] }) =>
				packageName ||
				includedOptionList?.reduce(
					(acc, io) =>
						io?.textMap?.description
							? acc.push(io.textMap.description) && acc
							: acc,
					[]
				)
		)
		?.join(',') || null;
